import { createApp } from 'vue'
import App from './App.vue'
import WapApp from './WapApp.vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import store from './store'
import { isWap } from './utils/index'

const wap = isWap()

if (wap) {
    createApp(WapApp).use(store).use(router).use(ElementPlus).mount('#app');
}
else {
    createApp(App).use(store).use(router).use(ElementPlus).mount('#app');
}

